import { FC } from 'react';
import { Button, Card, Input } from '@features/ui';
import {
  DisplayOptionsFormData,
  schemaDisplayOptions,
} from '@src/types/exchangePackages.ts';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface DisplayOptionsProps {
  values?: DisplayOptionsFormData;
  onSubmit?: (values: DisplayOptionsFormData) => void;
}
export const DisplayOptions: FC<DisplayOptionsProps> = ({
  values,
  onSubmit,
}) => {
  const handleSubmitForm = (data: DisplayOptionsFormData) => {
    onSubmit?.(data);
  };

  const { control, handleSubmit } = useForm<DisplayOptionsFormData>({
    resolver: yupResolver(schemaDisplayOptions),
    defaultValues: values,
  });

  return (
    <form autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
      <Card className={'gap-y-8'}>
        <div className={'flex flex-col max-w-[892px] text-xs gap-y-5'}>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'font-bold'}>Display Name (Web)</p>
            <div className={'flex lg:flex-row flex-col w-full gap-10'}>
              <Controller
                control={control}
                name="displayName1"
                render={({ field }) => (
                  <Input
                    className={'lg:max-w-[426px] max-w-full'}
                    textSize={'xs'}
                    variant={'secondary'}
                    {...field}
                  />
                )}
              />
              <Controller
                control={control}
                name="displayName2"
                render={({ field }) => (
                  <Input
                    className={'lg:max-w-[426px] max-w-full'}
                    textSize={'xs'}
                    variant={'secondary'}
                    {...field}
                  />
                )}
              />
            </div>
          </div>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'font-bold'}>Purchase Price $</p>
            <Controller
              control={control}
              name="purchasePrice"
              render={({ field }) => (
                <Input
                  className={'lg:max-w-[426px] max-w-full'}
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              )}
            />
          </div>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'font-bold'}>Max Contracts</p>
            <Controller
              control={control}
              name="maxContracts"
              render={({ field }) => (
                <Input
                  placeholder={'Up to 15 contracts'}
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              )}
            />
          </div>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'font-bold'}>Drawdown Info</p>
            <Controller
              control={control}
              name="drawdownInfo"
              render={({ field }) => (
                <Input
                  placeholder={'$5,000 Trailing Drawdown'}
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              )}
            />
          </div>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'font-bold'}>Footer Info</p>
            <Controller
              control={control}
              name="footerInfo"
              render={({ field }) => (
                <Input
                  placeholder={
                    'eg. Refundable. Over $125,000 refunded to our traders'
                  }
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              )}
            />
          </div>
          <div className={'flex flex-col gap-y-3.5'}>
            <p className={'ml-3'}>Shows under the details on website</p>
            <div className={'flex lg:flex-row flex-col w-full gap-10'}>
              <Controller
                control={control}
                name="detailMin"
                render={({ field }) => (
                  <Input
                    className={'lg:max-w-[426px] max-w-full h-9.5'}
                    textSize={'xs'}
                    variant={'secondary'}
                    {...field}
                  />
                )}
              />
              <Controller
                control={control}
                name="detailMax"
                render={({ field }) => (
                  <div
                    className={
                      'flex lg:max-w-[426px] max-w-full w-full flex-col gap-y-3'
                    }
                  >
                    <Input
                      textSize={'xs'}
                      variant={'secondary'}
                      {...field}
                      className={'h-9.5'}
                    />
                    <p>
                      Applies custom class name to package on front-end website
                    </p>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
        <div className={'flex w-full justify-end'}>
          <Button
            className={'mt-6 mb-1 w-[72px]'}
            size={'sm'}
            type={'submit'}
            variant={'lime'}
          >
            Save
          </Button>
        </div>
      </Card>
    </form>
  );
};
